import React from "react";

// Clear (x) control for search inputs. The caller passes `className` so the
// button can sit inline in a flex row or be absolutely positioned inside a
// padded input.
const SearchClearButton = ({
  onClear,
  className = "",
  label = "Clear search",
}) => (
  <button
    type="button"
    onClick={onClear}
    aria-label={label}
    title={label}
    className={`flex items-center justify-center text-jacarta-400 hover:text-jacarta-700 dark:text-jacarta-300 dark:hover:text-white transition-colors ${className}`}
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
);

export default SearchClearButton;
